// @ts-nocheck
import React, { useState, useEffect } from "react";
import { AverageHeartsGraph } from ".";
import {
  useGetAverageHeartsByAccountIdQuery,
  LineChartFilter,
  DataSourcePlatform,
} from "src/generated/ApolloComponents";

interface Props {
  accountId?: string;
  username: string;
  platformType: string;
  onChangeData?: (data) => void;
}

export const AverageHeartsGraphContainer: React.FC<Props> = ({
  accountId,
  username,
  platformType,
  onChangeData,
}) => {
  const [period, setPeriod] = useState("HalfYear");

  let queryData = {
    username: username,
    filter: period as LineChartFilter,
    platformType: platformType as DataSourcePlatform,
  } as any;

  if (accountId) {
    queryData["accountId"] = accountId;
  }

  const { data, loading, error } = useGetAverageHeartsByAccountIdQuery({
    variables: queryData,
  });

  const graphData = data?.getAverageHeartsByAccountId || [];

  useEffect(() => {
    if (onChangeData) onChangeData(graphData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [graphData]);

  let lastItem = graphData.filter(x => x?.value != null).slice(-1)[0];

  if (!loading && (error || graphData?.length === 0)) return null;

  return (
    <AverageHeartsGraph
      loading={loading}
      data={graphData}
      period={period}
      setPeriod={value => setPeriod(value)}
      titleValue={lastItem?.value}
    />
  );
};
